import React from 'react';

import VideoPlayer from '../videoComponents/VideoPlayer';
import './FixedPromoVideo.css';


const FixedPromoVideo = (props) => {
  const { close, videoImage, displayFixedVideo, user, homePage } = props;

  function handleClose() {
    close();
    sessionStorage.setItem('HIDE_FIXED_VIDEO', true);
  }

  if (!displayFixedVideo) {
    return null;
  }

  return (
    <div className="fixed-promo-video">
      <span className="fixed-video-close" onClick={handleClose}>
        X
      </span>
      <VideoPlayer
        autoPlayVideo={true}
        homePage={homePage}
        loopVideo={true}
        mutedVideo={true}
        user={user}
      />
      <a href="/account/purchase">
        <img alt="Promotion" src={videoImage} width="300px" />
      </a>
    </div>
  );
};

export default FixedPromoVideo;
